import { usePrefs } from 'wsm-common-data';

/**
 * Determines whether the gallery modal should use a horizontal thumbnail layout.
 * Reads the `galleryModalThumbs` pref and returns true when its value is 'horizontal'.
 *
 * @returns {boolean} isHorizontalLayout
 */
const useHorizontalLayout = () => {
	const { galleryModalThumbs } = usePrefs();
	return galleryModalThumbs === 'horizontal';
};

export default useHorizontalLayout;
